import { Logout } from '@mui/icons-material';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import {
  Box,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import { useContext } from 'react';
import { NavLink as RouterLink, useLocation } from 'react-router-dom';
import MediKreditPoll from '../../../../components/mediKreditPoll/MediKreditPoll';
import Icon from '../../../../components/SVGIcons';
import TenantSelect from '../../../../components/tenantSelect/TenantSelect';
import UserInfo from '../../../../components/UserInfo/UserInfo';
import { SidebarContext } from '../../../../context/SidebarContext';
import { env } from '../../../../env';
import { useAuth } from '../../../../features/authentication';
import pages from '../../../../router/routes';
import { useCompanyStore } from '../../../../store/company/companyStore';

function SidebarMenu() {
  const { closeSidebar } = useContext(SidebarContext);
  const location = useLocation();
  const companies = useCompanyStore((state) => state.companies);
  const activeCompany = useCompanyStore((state) => state.activeCompany);

  const { logout } = useAuth();

  const canAccessCustomerProducts = activeCompany?.role?.name === 'Admin';
  const canAccessTransactions = activeCompany?.role?.name === 'Admin';
  const canAccessSettings = activeCompany?.role?.name === 'Admin';

  const handleLogout = () => {
    try {
      logout();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <List
        component="div"
        disablePadding
        sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}
      >
        <Stack
          sx={{ alignItems: 'center', justifyContent: 'space-evenly' }}
          direction={'column'}
          spacing={1}
        >
          <Typography variant="caption">v{`${env.VITE_VERSION}`}</Typography>
          <MediKreditPoll />
        </Stack>
      </List>
      <List component="div" disablePadding>
        <List component="div">
          <ListItem component="div">
            <TenantSelect practices={companies} />
          </ListItem>
        </List>

        <List
          component="div"
          disablePadding
          sx={{
            display: 'flex',
            flexDirection: 'column',
            paddingLeft: '20px',
          }}
        >
          <ListItem disablePadding>
            <ListItemButton
              selected={location.pathname === pages.products.path}
              component={RouterLink}
              onClick={closeSidebar}
              to={pages.products.path}
              id="products-nav"
            >
              <ListItemIcon>
                <Icon name="ShoppingCartIcon" />
              </ListItemIcon>
              <ListItemText primary=" Products" />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton
              selected={location.pathname === pages.customers.path}
              component={RouterLink}
              onClick={closeSidebar}
              to={pages.customers.path}
              id="customers-nav"
            >
              <ListItemIcon>
                <Icon name="UsersIcon" />
              </ListItemIcon>
              <ListItemText primary=" Customers" />
            </ListItemButton>
          </ListItem>

          {canAccessCustomerProducts && (
            <ListItem disablePadding>
              <ListItemButton
                selected={location.pathname === pages.customerProducts.path}
                component={RouterLink}
                onClick={closeSidebar}
                to={pages.customerProducts.path}
                id="customer-products-nav"
              >
                <ListItemIcon>
                  <Icon name="UsersIcon" />
                </ListItemIcon>
                <ListItemText primary=" Customer Products" />
              </ListItemButton>
            </ListItem>
          )}

          {canAccessTransactions && (
            <ListItem disablePadding>
              <ListItemButton
                selected={location.pathname === pages.transactions.path}
                component={RouterLink}
                onClick={closeSidebar}
                to={pages.transactions.path}
                id="transactions-nav"
              >
                <ListItemIcon>
                  <Icon name="MoneyBillStackIcon" />
                </ListItemIcon>
                <ListItemText primary=" Transactions" />
              </ListItemButton>
            </ListItem>
          )}
        </List>

        <Box
          sx={{
            position: 'fixed',
            bottom: 0,
          }}
        >
          <List
            component="div"
            sx={{
              paddingLeft: '20px',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {canAccessSettings && (
              <ListItem disablePadding>
                <ListItemButton
                  selected={location.pathname === pages.settings.path}
                  component={RouterLink}
                  onClick={closeSidebar}
                  to={pages.settings.path}
                  id="settings-nav"
                >
                  <ListItemIcon>
                    <SettingsOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText primary="Settings" />
                </ListItemButton>
              </ListItem>
            )}
            <ListItem component="div" disablePadding>
              <Box textAlign="center" sx={{ width: '220px' }}>
                <UserInfo />
                <Typography>{activeCompany?.role?.name}</Typography>
              </Box>
            </ListItem>
            <ListItem component="div" disablePadding>
              <Box sx={{ width: '220px', paddingTop: '16px' }}>
                <Button
                  sx={{ width: '100%' }}
                  variant="contained"
                  disableRipple
                  onClick={handleLogout}
                  endIcon={<Logout />}
                >
                  Logout
                </Button>
              </Box>
            </ListItem>
          </List>
        </Box>
      </List>
    </>
  );
}

export default SidebarMenu;
